
import { WebClient } from "./server/WebClient";

export const TextToSpeechService = {
    getToken: () => WebClient.Get<string>("/api/TextToSpeech/GetToken")
}